import _ from 'lodash';
import RequestError from './RequestError';
import amProxyUrl from './AmProxyUrl';
import api from '@/api';

export default {
	createHighlight,
	deleteHighlight,
	getHighlight,
	getHighlightbyid,
	setHighlightName,
	checkDisabled,
};

function createHighlight(name, desc, id) {
	return makeRequest({
		path: '/highlight',
		method: 'post',
		data: {
			name: name, description: desc, stream: id
		}
	});
}

function checkDisabled(highlightId, status) {
	return makeRequest({
		path: `/highlight/${highlightId}`,
		method: 'put',
		data: { isDisabled: status }
	});
}

function deleteHighlight(highlightId) {
	return makeRequest({
		path: `/highlight/${highlightId}`,
		method: 'delete',
	});
}

function setHighlightName(highlightId, name, desc = '') {
	return makeRequest({
		path: `/highlight/${highlightId}`,
		method: 'put',
		data: {
			name: name, description: desc
		}
	});
}

function getHighlight() {
	return makeRequest({
		path: '/highlight',
		method: 'get',
	});
}

function getHighlightbyid(highlightId) {
	return makeRequest({
		path: `/highlight/${highlightId}`,
		method: 'get',
	});
}

async function makeRequest(reqConfig, preventProxy, throwReal) {
	if (typeof reqConfig === 'string') {
		reqConfig = {
			path: reqConfig,
		};
	}

	if (preventProxy !== true) {
		reqConfig = amProxyUrl(reqConfig, process.env.VUE_APP_VOD_API_BASE_URL);
	}

	reqConfig.url = reqConfig.path;

	let res;
	try {
		res = await api.request(reqConfig);
	} catch (err) {
		if (throwReal) {
			throw err;
		}
		const edata = _.get(err, 'response.data');
		throw new RequestError(edata);
	}

	return res && res.data;
}
